import { ValueError } from "../error/ValueError.js";
import { isIterable } from "./iterate.js";
import { isObject, isPlainObject } from "./object.js";
/** Is an unknown value a data object? */
export function isData(value) {
    return isPlainObject(value);
}
/** Assert that an unknown value is a data object. */
export function assertData(value) {
    if (!isPlainObject(value))
        throw new ValueError("Must be data", value);
}
/** Is an unknown value the key for an own prop of a data object. */
export const isDataProp = (data, key) => typeof key === "string" && Object.hasOwn(data, key);
/** Assert that an unknown value is the key for an own prop of a data object. */
export function assertDataProp(data, key) {
    if (!isDataProp(data, key))
        throw new ValueError("Must be data prop", key);
}
export function getData(input) {
    return isIterable(input) ? Object.fromEntries(input) : input;
}
export function getDataProps(data) {
    return Object.entries(data);
}
export function getDataKeys(data) {
    return Object.keys(data);
}
export function getDataProp(data, key) {
    let current = data;
    for (const k of key.split(".")) {
        if (!isObject(current))
            return undefined;
        current = current[k];
    }
    return current;
}
/** An empty object. */
export const EMPTY_DATA = { __proto__: null };
/** Function that returns an an empty object. */
export const getEmptyData = () => EMPTY_DATA;
